<span class="dialpad instacall">
  <div class="dialpad-flex-container">
    @for (button of dialpadButtons; track button) {
    <onsip-dialpad-button
      onsipDtmfEnabled
      [dtmfEnabled]="true"
      [target]="'instacall'"
      [isDialpadComponent]="true"
      [dtmfKey]="button.number"
      [dtmfLetters]="button.letters"
    >
    </onsip-dialpad-button>
    }
  </div>
</span>
